import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { omit } from "lodash";
import axios from "axios";
import { useLocation } from "react-router";
import { Button, Modal, Row, Space, Spin } from "antd";
import { Link } from "react-router-dom";
import TaskList from "../../components/tasks/TaskList/TaskList";
import { clearTask, fetchTaskById, fetchTasks } from "../../store/slices/tasks";
import { baseUrl } from "../../lib/routes/baseUrl";
import {
  toHttpFormat,
  toHttpFormatEndOfDay,
  toHttpFormatStartOfDay,
} from "../../lib/utils/formatDate";
import SubtasksTableContainer from "../SubtasksTableContainer/SubtasksTableContainer";
import { checkIsLoaded } from "../../lib/utils/checkLoadingStatus";

interface ITaskListContainer {
  setTaskIdForReprocess: any;
  setIsModalConfirmationVisible: any;
  filters: any;
  setFilters: any;
  currentPage: number;
  setCurrentPage: (page: number) => void;
  setMainTask: () => void;
  isReprocessRunning: boolean;
  currentTaskId: number | null;
  setCurrentTaskId: React.Dispatch<React.SetStateAction<number | null>>;
}

function TaskListContainer(props: ITaskListContainer) {
  const {
    setIsModalConfirmationVisible,
    setTaskIdForReprocess,
    filters,
    setFilters,
    currentPage,
    setCurrentPage,
    setMainTask,
    isReprocessRunning,
    currentTaskId,
    setCurrentTaskId,
  } = props;
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [formUsers, setFormUsers] = useState([]);
  const {
    tasks: { content: tasks },
    taskTypes: { content: taskTypes },
    taskLoading,
    // @ts-ignore
  } = useSelector((state) => state.tasks);
  const { pathname } = useLocation();
  let timeout;
  const task = currentTaskId && tasks.find(({ id }) => String(id) === String(currentTaskId));
  const taskType = taskTypes && taskTypes.find(({ id: ttId }) => ttId === task?.type);

  const [subTasksCurrentPage, setSubTasksCurrentPage] = useState(1);

  function getUsers(value) {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
    function fetchUsers() {
      axios
        .get(`${baseUrl}/security-api/users/pageable-search`, {
          params: {
            fullName: value,
          },
        })
        .then((res) => {
          setFormUsers(res.data.content);
        });
    }

    timeout = setTimeout(fetchUsers, 500);
  }

  const getTask = (taskId) => {
    // @ts-ignore
    dispatch(fetchTaskById({ taskId, includeChildren: false }));
  };

  const getTasks = (params) => {
    const newParams = { ...params };
    let createDateFrom;
    let createDateTo;
    let status;
    let userScopeId;
    if (newParams?.createDate) {
      createDateFrom = toHttpFormat(newParams.createDate[0]);
      createDateTo = toHttpFormat(newParams.createDate[1]);
      delete newParams.createDate;
    }
    if (newParams?.status) {
      status = newParams.status.toString();
    }
    if (newParams?.userScopeId) {
      userScopeId = newParams.userScopeId.toString();
    }
    dispatch(
      // @ts-ignore
      fetchTasks({
        queryParams: {
          ...omit(newParams, "initiator"),
          status,
          userScopeId,
          createDateFrom: createDateFrom && toHttpFormatStartOfDay(createDateFrom),
          createDateTo: createDateTo && toHttpFormatEndOfDay(createDateTo),
          includeChildren: false,
          userId: newParams?.initiator,
          page: currentPage - 1,
          size: 20,
          sort: "createDate,desc",
          advancedSearch: false,
        },
      })
    );
  };

  useEffect(() => {
    if (filters) getTasks(filters);
    else getTasks({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  return (
    <>
      <Modal
        title={taskType?.title}
        visible={isModalVisible}
        footer={null}
        className="tasks-details__modal"
        onCancel={() => {
          setIsModalVisible(false);
          setSubTasksCurrentPage(1);
          if (filters) getTasks(filters);
          else getTasks({});
        }}
        width="96vw"
        bodyStyle={{
          minHeight: "515.6px",
        }}
      >
        {checkIsLoaded(taskLoading) ? (
          <Spin spinning={isReprocessRunning}>
            <SubtasksTableContainer
              taskId={currentTaskId}
              subtasksStatusForFetching={4}
              setTaskIdForReprocess={setTaskIdForReprocess}
              setIsModalConfirmationVisible={setIsModalConfirmationVisible}
              subTasksCurrentPage={subTasksCurrentPage}
              setSubTasksCurrentPage={setSubTasksCurrentPage}
            />
            <Row justify="center" style={{ marginTop: 10 }}>
              <Space>
                <Link to={`${pathname}/${currentTaskId}/detalization`}>
                  <Button
                    onClick={() => {
                      // @ts-ignore
                      dispatch(clearTask());
                      setIsModalVisible(false);
                    }}
                    className="button_small"
                  >
                    Перейти в детализацию
                  </Button>
                </Link>
                <Button
                  type="primary"
                  onClick={() => {
                    setIsModalVisible(false);
                    if (filters) getTasks(filters);
                    else getTasks({});
                  }}
                  className="button_small"
                >
                  Ок
                </Button>
              </Space>
            </Row>
          </Spin>
        ) : (
          <Spin />
        )}
      </Modal>
      <TaskList
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
        setCurrentTaskId={setCurrentTaskId}
        // @ts-ignore
        currentTaskId={currentTaskId}
        setTaskIdForReprocess={setTaskIdForReprocess}
        setIsModalConfirmationVisible={setIsModalConfirmationVisible}
        getTask={getTask}
        getUsers={getUsers}
        formUsers={formUsers}
        filters={filters}
        setFilters={setFilters}
        getTasks={getTasks}
        setIsModalVisible={setIsModalVisible}
        setMainTask={setMainTask}
        setFormUsers={setFormUsers}
      />
    </>
  );
}

export default TaskListContainer;
